define('static/js/regist', function(require, exports, module) {

  /**
   * Created by Administrator on 2016/1/15.
   */
  var api = require('static/js/api');
  const { captcha } = require('static/js/captcha');
  
  var registObj = {
    init: function () {
  
      require(['static/js/jquery','static/js/common','static/js/cookie','static/js/proxy','static/js/language','static/js/jQueryMd5'], function ($, commonJS, cookieJS, proxyJS, languageJS) {
        commonJS.commonObj.init();
        var cookie = cookieJS.cookie;
        var appID = proxyJS.proxyObj.appId;
        var appKey = proxyJS.proxyObj.appKey;
        var channelID = getQueryVariable('channelID') ? getQueryVariable('channelID') : proxyJS.proxyObj.channelID;
        var subChannelID = getQueryVariable('subChannelID') ? getQueryVariable('subChannelID') : proxyJS.proxyObj.channelID;;
        initUI.apply(this);
        function getQueryVariable(variable) {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
          }
          return (false);
        }
        //var appId=getQueryVariable('appID')?getQueryVariable('appID'):proxyJS.proxyObj.appId
        function initUI() {
  
          var _isPhoneCode = false;
          var _isMailCode = false;
  
          function resetRegistUI() {
            $('#phone-num').val($('#phone-num')[0].defaultValue);
            $('#phone-numRightTip').hide();
            $('#phone-numErrorTip').hide();
  
            $('#phone-pwd').val('');
            $('#phone-pwdWarn').show();
            $('#phone-pwdRightTip').hide();
            $('#phone-pwdErrorTip').hide();
  
            $('#phone-repwd').val('');
            $('#phone-repwdWarn').show();
            $('#phone-repwdRightTip').hide();
            $('#phone-repwdErrorTip').hide();
  
            $('#phoneRealName').val($('#phoneRealName')[0].defaultValue);
            $('#phoneRealNum').val($('#phoneRealNum')[0].defaultValue);
  
  
            $('#phone-code').val($('#phone-code')[0].defaultValue);
            $('#phone-codeRightTip').hide();
            $('#phone-codeErrorTip').hide();
  
            //mail regist
            $('#mail-num').val($('#mail-num')[0].defaultValue);
            $('#mail-numRightTip').hide();
            $('#mail-numErrorTip').hide();
  
            $('#mail-pwd').val('');
            $('#mail-pwdWarn').show();
            $('#mail-pwdRightTip').hide();
            $('#mail-pwdErrorTip').hide();
  
            $('#mail-repwd').val('');
            $('#mail-repwdWarn').show();
            $('#mail-repwdRightTip').hide();
            $('#mail-repwdErrorTip').hide();
  
            $('#mailRealName').val($('#mailRealName')[0].defaultValue);
            $('#mailRealNum').val($('#mailRealNum')[0].defaultValue);
  
            $('#mail-code').val($('#mail-code')[0].defaultValue);
            $('#mail-codeRightTip').hide();
            $('#mail-codeErrorTip').hide();
          }
  
          function initRegistNav() {
            var _registIndex = 0;
            updateRegistNavByIndex(_registIndex);
            $('#regist-navList li').click(function () {
              resetRegistUI();
              _registIndex = $(this).index();
              updateRegistNavByIndex(_registIndex);
            });
  
            function updateRegistNavByIndex(index) {
              if (index == 0) {
                $('#regist-mailBox').hide();
                $('#regist-phoneBox').show();
              } else {
                $('#regist-mailBox').show();
                $('#regist-phoneBox').hide();
              }
  
  
              $('#regist-navList li').each(function () {
                if ($(this).index() == index) {
                  $(this).css({
                    'background-color': '#4d4d4d'
                  });
                  $(this).find('p').css({
                    'color': '#fff'
                  });
                  $(this).find('.regist-navBg').show();
                } else {
                  $(this).css({
                    'background-color': '#fff'
                  });
                  $(this).find('p').css({
                    'color': '#7d7d7d'
                  });
  
                  $(this).find('.regist-navBg').hide();
                }
              });
            }
          }
  
          //废除验证码前端及时验证
          /*function reqCheckForCapchaAjax(userID, type, codeID) {
              userID = userID.indexOf('#') == -1 ? "#" + userID : userID;
              codeID = codeID.indexOf('#') == -1 ? "#" + codeID : codeID;
  
              var appId = proxyJS.proxyObj.appId;
              var appKey = proxyJS.proxyObj.appKey;
              var username = $(userID).val();
              var from = 'register';
              var type = type;
              var captcha = $(codeID).val();
              var signature = appId + username + from + type + captcha + appKey;
              var signatureMd5 = $.md5(signature);
  
              var succFunc = function (res) {
                  switch (type) {
                      case 'phone':
                          _isPhoneCode = true;
                          commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, true, '');
                          break;
                      case 'email':
                          _isMailCode = true;
                          commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', false, true, '');
                          break;
                  }
              };
  
              var errorFunc = function (res) {
                  switch (type) {
                      case 'phone':
                          commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, '请输入有效的手机验证码');
                          break;
                      case 'email':
                          commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', false, false, '请输入有效的邮箱验证码');
                          break;
                  }
              };
  
  
              proxyJS.proxyObj.reqCheckPhoneOrMailCapchaAjax({
                  action: 'validate',
                  appId: appId,
                  username: username,
                  from: from,
                  type: type,
                  captcha: captcha,
                  signature: signatureMd5,
                  success: succFunc,
                  error: errorFunc
              });
          }*/
  
          /**********  phone regist start **********/
  
          function initPhonePanelLogic() {
            var _isPhoneNum = false;
            var _isPhonePwd = false;
            var _isPhoneRePwd = false;
            var _isPhoneName = false;
            var _isPersonCard = false;
            var _isPhoneCooling = false;
            var _isPhoneProxy = true;
            var _isPhoneId = 0;
            var _isPhoneTotalTime = 60;
            var _isCodeNum = false;
            var _isPhoneHasCode = false;
  
            function startPhoneCooling() {
              clearInterval(_isPhoneId);
              _isPhoneCooling = true;
              _isPhoneTotalTime = 60;
              _isPhoneId = setInterval(updatePhoneCooking, 1000);
              $('#phone-getCodeBtn').html(_isPhoneTotalTime + "秒后重发");
            }
  
            function updatePhoneCooking() {
              _isPhoneTotalTime--;
              $('#phone-getCodeBtn').html(_isPhoneTotalTime + "秒后重发");
              if (_isPhoneTotalTime <= 0) {
                clearInterval(_isPhoneId);
                _isPhoneCooling = false;
                $('#phone-getCodeBtn').html('获取手机验证码');
              }
            }
  
            /**********  personal real name start **********/
            $('#phoneRealName').focusin(function () {
              var $ele = $(this);
              if ($ele.val() == this.defaultValue) {
                $ele.val('');
              }
              commonJS.commonObj.controlWarnTips('#phoneRealNameRTip', '#phoneRealNameETip', true, false, '');
              _isPhoneName = false;
            }).blur(function () {
              var $ele = $(this);
              if ($.trim($ele.val()) == '') {
                $ele.val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#phoneRealNameRTip', '#phoneRealNameETip', true, false, '');
                _isPhoneName = false;
              } else {
                if (languageJS.languageObj.IsRealName($ele.val()) == true) {
                  commonJS.commonObj.controlWarnTips('#phoneRealNameRTip', '#phoneRealNameETip', false, true, '');
                  _isPhoneName = true;
                } else {
                  commonJS.commonObj.controlWarnTips('#phoneRealNameRTip', '#phoneRealNameETip', false, false, '请输入真实的姓名');
                  _isPhoneName = false;
                }
              }
            });
  
            /**********  personal card start **********/
            $('#phoneRealNum').focusin(function () {
              var $ele = $(this);
              if ($ele.val() == this.defaultValue) {
                $ele.val('');
              }
              commonJS.commonObj.controlWarnTips('#phoneRealNumRTip', '#phoneRealNumETip', true, false, '');
              _isPersonCard = false;
            }).blur(function () {
  
              var $ele = $(this);
              if ($.trim($ele.val()) == '') {
                $ele.val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#phoneRealNumRTip', '#phoneRealNumETip', true, false, '');
                _isPersonCard = false;
              } else {
                var nowStr = $ele.val();
  
                var info = commonJS.commonObj.isCardID(nowStr);
                if (info == '') {
                  commonJS.commonObj.controlWarnTips('#phoneRealNumRTip', '#phoneRealNumETip', false, true, '');
                  _isPersonCard = true;
                } else {
                  commonJS.commonObj.controlWarnTips('#phoneRealNumRTip', '#phoneRealNumETip', false, false, info);
                  _isPersonCard = false;
                }
              }
  
            });
  
            /**********  phone account start **********/
            $("#phone-num").focusin(function () {
              if ($(this).val() == this.defaultValue) {
                $(this).val('');
              }
              commonJS.commonObj.controlWarnTips('#phone-numRightTip', '#phone-numErrorTip', true, false, '');
              _isPhoneNum = false;
            }).blur(function () {
              var numStr = $('#phone-num').val();
              if ($.trim($(this).val()).length == 0) {
                $(this).val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#phone-numRightTip', '#phone-numErrorTip', true, false, '');
                _isPhoneNum = false;
              } else {
  
                if (languageJS.languageObj.IsMobile(numStr) == true) {
                  _isPhoneNum = true;
                  commonJS.commonObj.controlWarnTips('#phone-numRightTip', '#phone-numErrorTip', false, true, '');
                } else {
                  commonJS.commonObj.controlWarnTips('#phone-numRightTip', '#phone-numErrorTip', false, false, languageJS.languageObj.PHONE_TRUE_FORMAT);
                  _isPhoneNum = false;
                }
              }
            });
  
            /**********  phone password start **********/
            $('#phone-pwdWarn').focusin(function () {
              $('#phone-pwdWarn').hide();
              $("#phone-pwd").show();
              $("#phone-pwd").focus();
            });
            $('#phone-pwd').focusin(function () {
              $('#phone-pwdWarn').hide();
              commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', true, false, '');
            }).on('blur', function () {
              /*var oldStr = $(this).val();
              $(this).val(oldStr.replace(/\s/g, ''));*/
  
              //_isPhonePwd = false;
              var numStr = $('#phone-pwd').val();
              if (numStr.length > 0) {
  
                if (languageJS.languageObj.IsPWD(numStr) == true) {
                  _isPhonePwd = true;
                  commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, true, '');
                  var rePwd = $('#phone-repwd').val();
  
                  if (rePwd.length > 0) {
                    if (languageJS.languageObj.IsPWD(rePwd) == true) {
                      if (numStr == rePwd) {
                        _isPhonePwd = true;
                        _isPhoneRePwd = true;
                        commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', false, true, '');
                        commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, true, '');
                      } else {
                        commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, false, languageJS.languageObj.PWD_NOT_SAME);
                      }
                    } else {
                      commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                    }
                  }
                } else {
                  commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                  _isPhonePwd = false;
                }
              } else {
                $('#phone-pwd').hide();
                $('#phone-pwdWarn').show();
                commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', true, false, '');
                _isPhonePwd = false;
              }
            });
  
            /**********  phone repeat password start **********/
            $('#phone-repwdWarn').focusin(function () {
              $('#phone-repwdWarn').hide();
              $("#phone-repwd").show();
              $("#phone-repwd").focus();
            });
            $('#phone-repwd').focusin(function () {
              $('#phone-repwdWarn').hide();
              commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', true, false, '');
            }).on('blur', function () {
              /*var oldStr = $(this).val();
              $(this).val(oldStr.replace(/\s/g, ''));
  
              _isPhoneRePwd = false;*/
  
              var numStr = $('#phone-repwd').val();
  
              if (numStr.length > 0) {
                if (languageJS.languageObj.IsPWD(numStr) == true) {
                  _isPhoneRePwd = true;
                  commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', false, true, '');
  
                  var pwdStr = $('#phone-pwd').val();
                  if (languageJS.languageObj.IsPWD(pwdStr) == true) {
                    if (numStr != pwdStr) {
                      commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', false, false, languageJS.languageObj.PWD_NOT_SAME);
                      _isPhoneRePwd = false;
                    } else {
                      _isPhonePwd = true;
                      _isPhoneRePwd = true;
                      commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', false, true, '');
                      commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, true, '');
                    }
                  } else {
                    commonJS.commonObj.controlWarnTips('#phone-pwdRightTip', '#phone-pwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                  }
                } else {
                  commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                  _isPhoneRePwd = false;
                }
              } else {
                $('#phone-repwd').hide();
                $('#phone-repwdWarn').show();
                commonJS.commonObj.controlWarnTips('#phone-repwdRightTip', '#phone-repwdErrorTip', true, false, '');
                _isPhoneRePwd = false;
              }
            });
  
            /**********  phone code start **********/
            $('#phone-code').focusin(function () {
              if ($(this).val() == this.defaultValue) {
                $(this).val('');
              }
              commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', true, false, '');
              _isCodeNum = false;
            }).blur(function () {
              if ($.trim($(this).val()) == '') {
                $(this).val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', true, false, '');
                _isCodeNum = false;
              }
            }).on('keyup', function () {
  
              var telNum = $('#phone-num').val();
              if (_isPhoneNum == true) {
                /*  var oldStr = $(this).val();
                  $(this).val(oldStr.replace(/\s/g, ''));*/
  
                _isPhoneCode = false;
                _isCodeNum = false;
                if (_isPhoneHasCode == false) {
                  commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, '点击获取验证码');
                } else {
                  var numStr = $('#phone-code').val();
                  if (numStr.length > 0) {
                    if (numStr.length < 6) {
                      commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, '手机验证码需6位');
                    } else {
                      /*var phoneNumStr = $('#phone-num').val();
                      if (languageJS.languageObj.IsMobile(phoneNumStr) == true) {
                          reqCheckForCapchaAjax('phone-num', 'phone', 'phone-code')
                      } else {
                          commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', true, false, '');
                      }*/
                      commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', true, true, '');
                      _isPhoneCode = true;
                      _isCodeNum = true;
                    }
                  } else {
  
                    commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, '请输入手机验证码');
                  }
                }
              } else {
                $(this).val('');
                commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, languageJS.languageObj.PHONE_TRUE_FORMAT);
  
              }
  
            })
            $('#phone-acceptBtn').click(function () {
              var errorStr = "";
  
              var phoneNum = $('#phone-num').val();
              var phoneDef = $('#phone-num')[0].defaultValue;
              var pwdStr = $('#phone-pwd').val();
              var pwdReStr = $('#phone-repwd').val();
              var realNameStr = $('#phoneRealName').val();
              var realNameDef = $('#phoneRealName')[0].defaultValue;
              var realNumStr = $('#phoneRealNum').val();
              var realNumDef = $('#phoneRealNum')[0].defaultValue;
              var codeStr = $('#phone-code').val();
              var codeDefStr = $('#phone-code')[0].defaultValue;
              //    alert() 
              function textlength(res) {
                var len = 0;
                var str = res;
                for (var i = 0; i < str.length; i++) {
                  var c = str.charCodeAt(i);
                  //单字节加1
                  if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                    len++;
                  }
                  else {
                    len += 2;
                  }
                }
                return len
              };
              // if(textlength(realNameStr)<4){
              //     alert("姓名不能少于两位汉字");
              // }
              if (phoneNum == phoneDef) {
                $('#error-msg').html(phoneDef)
  
                alert(phoneDef);
              } else {
                if (_isPhoneNum == true) {
                  if (pwdStr.length > 0) {
                    if (_isPhonePwd == true) {
                      if (pwdReStr.length > 0) {
                        if (_isPhoneRePwd == true) {
                          if (pwdStr != pwdReStr) {
                            $('#error-msg').html(languageJS.languageObj.PWD_NOT_SAME)
                            alert(languageJS.languageObj.PWD_NOT_SAME);
                          } else {
                            if (realNameStr == realNameDef) {
                $('#error-msg').html("请输入真实姓名")
  
                              alert("请输入真实姓名");
                            } else if (textlength(realNameStr) < 4) {
                $('#error-msg').html("姓名不能少于两位汉字")
  
                              alert("姓名不能少于两位汉字");
                            } else {
                              if (_isPhoneName == true) {
                                if (realNumStr == realNumDef) {
                $('#error-msg').html("请输入身份证号码")
  
                                  alert("请输入身份证号码");
                                } else {
  
                                  if (_isPersonCard == true) {
  
  
                                    // alert(codeDefStr);
                                    // alert(codeStr)
                                    if (codeStr == codeDefStr) {
  
                                      $('#error-msg').html(codeDefStr)
  
                                      alert(codeDefStr);
                                    } else {
  
  
                                      if (_isCodeNum == true) {
                                        if ($('#phone-proxyRight').is(':visible') == false) {
                $('#error-msg').html('您还没有阅读并同意相关服务条款和隐私政策')
  
                                          alert('您还没有阅读并同意相关服务条款和隐私政策');
                                        } else {
  
  
                                          commonRegistFunc('phone-num', 'phone-pwd', 'phone-repwd', 'phone-code', 'phoneRealName', 'phoneRealNum', 'phone');
                                        }
                                      }
                                    }
                                  }
  
                                }
                              }
  
                            }
                          }
                        }
                      } else {
                $('#error-msg').html('您还没有阅读并同意相关服务条款和隐私政策')
  
                        alert('请输入确认密码');
                      }
                    }
                  } else {
                $('#error-msg').html('请输入密码')
  
                    alert('请输入密码');
                  }
                }
              }
            })
  
            /**********  phone regist submit start **********/
            // $('#phone-acceptBtn').click(function () {
            //     var errorStr = "";
  
            //     var phoneNum = $('#phone-num').val();
            //     var phoneDef = $('#phone-num')[0].defaultValue;
            //     var pwdStr = $('#phone-pwd').val();
            //     var pwdReStr = $('#phone-repwd').val();
            //     var realNameStr = $('#phoneRealName').val();
            //     var realNameDef = $('#phoneRealName')[0].defaultValue;
            //     var realNumStr = $('#phoneRealNum').val();
            //     var realNumDef = $('#phoneRealNum')[0].defaultValue;
            //     var codeStr = $('#phone-code').val();
            //     var codeDefStr = $('#phone-code')[0].defaultValue;
  
            //     if (phoneNum == phoneDef) {
            //         alert(phoneDef);
            //     } else {
            //         if (_isPhoneNum == true) {
            //             if(pwdStr.length > 0 ){
            //                 if (_isPhonePwd == true) {
            //                     if(pwdReStr.length > 0){
            //                         if ( _isPhoneRePwd == true) {
            //                             if (pwdStr != pwdReStr) {
            //                                 alert(languageJS.languageObj.PWD_NOT_SAME);
            //                             } else {
            //                                 if(realNameStr == realNameDef){
            //                                     alert("请输入真实姓名");
            //                                 }else{
            //                                     if(_isPhoneName == true){
            //                                         if(realNumStr == realNumDef){
            //                                             alert ("请输入身份证号码");
            //                                         }else{
            //                                             if(_isPersonCard == true) {
            //                                                 if(codeStr == codeDefStr){
            //                                                     alert(codeDefStr);
            //                                                 }else{
            //                                                     if (_isCodeNum == true) {
            //                                                         if ($('#phone-proxyRight').is(':visible') == false) {
            //                                                             alert('您还没有阅读并同意相关服务条款和隐私政策');
            //                                                         }else {
            //                                                             commonRegistFunc('phone-num', 'phone-pwd', 'phone-code','phoneRealName','phoneRealNum');
            //                                                         }
            //                                                     }
            //                                                 }
            //                                             }
  
            //                                         }
            //                                     }
  
            //                                 }
            //                             }
            //                         }
            //                     }else{
            //                         alert('请输入确认密码');
            //                     }
            //                 }
            //             }else{
            //                 alert('请输入密码');
            //             }
            //         }
            //     }
  
            // });
  
            $('#phone-getCodeBtn').click(function () {
              if (_isPhoneCooling == true) {
                return;
              } else {
                if (_isPhoneHasCode == false) {
                  _isPhoneHasCode = true;
                }
  
                var phoneNumDefStr = $('#phone-num')[0].defaultValue;
                var phoneValStr = $('#phone-num').val();
  
                var errorStr = '';
                if (phoneValStr == phoneNumDefStr) {
                  errorStr = phoneNumDefStr;
                } else {
                  if (languageJS.languageObj.IsMobile(phoneValStr) == false) {
                    errorStr = languageJS.languageObj.PHONE_TRUE_FORMAT;
                  }
                }
  
                if (errorStr != '') {
                  alert(errorStr);
                } else {
                  captcha.init('registerPhoneCode', callBack)
                  var dialog = document.getElementById("ssj_dialog")
                  // if (typeof dialog.showModal === "function") {
                  //   dialog.showModal();
                  //   mask.style.display = "block";
                  // }
                  dialog.style.display = "block";
                  mask.style.display = "block";
  
                }
              }
  
            });
  
            function callBack(passToken) {
              startPhoneCooling();
  
              var appkey = proxyJS.proxyObj.appKey;
              var appId = proxyJS.proxyObj.appId;
              var phoneNum = $('#phone-num').val();
              var from = 'register';
              var type = 'phone';
              var signatureStr = appId + phoneNum + from + type + appkey;//appId+username+from+type+appkey
              var signatureMd5 = $.md5(signatureStr);
  
              var succFunc = function (data) {
              };
  
              var errorFunc = function (res) {
                alert(res.msg);
              }
              try{
                api.registerphoneCode({
                  username: phoneNum,
                  appID: appId,
                  appKey: appKey,
                  channelID: channelID,
                  subChannelID: subChannelID,
                  passToken: passToken,
                }, function (r) {
                  if(r.code==0){
                    succFunc(r)
                    $('#error-msg').html('')
  
                  }else{
                    alert(r.msg)
                   $('#error-msg').html(r.msg)
                  }
                })
              }catch{
                
              }
              
             
            }
  
            $('#phone-proxyRecBox').click(function () {
              _isPhoneProxy = !_isPhoneProxy;
              if (_isPhoneProxy) {
                $('#phone-proxyRight').show();
              } else {
                $('#phone-proxyRight').hide();
              }
            });
          }
  
          /**********  email regist start **********/
          function initMailPanelLogic() {
            //=================================mail logic==============================\
            var _isMailNum = false;
            var _isMailPwd = false;
            var _isMailRePwd = false;
            var _isMailName = false;
            var _isMailCard = false;
            var _isCodeNum = false;
            var _isMailCooling = false;
            var _isMailProxy = true;
            var _isMailId = 0;
            var _isMailTotalTime = 60;
            var _isMailHasCode = false;
  
            function startMailCooling() {
              clearInterval(_isMailId);
              _isMailCooling = true;
              _isMailTotalTime = 60;
              _isMailId = setInterval(updateMailCooking, 1000);
              $('#mail-getCodeBtn').html(_isMailTotalTime + "秒后重发");
            }
  
            function updateMailCooking() {
              _isMailTotalTime--;
              $('#mail-getCodeBtn').html(_isMailTotalTime + "秒后重发");
              if (_isMailTotalTime <= 0) {
                clearInterval(_isMailId);
                _isMailCooling = false;
                $('#mail-getCodeBtn').html('获取邮箱验证码');
              }
            }
  
  
            $('#mailRealName').focusin(function () {
              var $ele = $(this);
              if ($ele.val() == this.defaultValue) {
                $ele.val('')
              }
              commonJS.commonObj.controlWarnTips('#phoneRealNameRTip', '#phoneRealNameETip', true, false, '');
              _isMailName = false;
            }).blur(function () {
              var $ele = $(this);
              if ($.trim($ele.val()) == '') {
                $ele.val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#mailRealNameRTip', '#mailRealNameETip', true, false, '');
                _isMailName = false;
              } else {
                if (languageJS.languageObj.IsRealName($ele.val()) == true) {
                  commonJS.commonObj.controlWarnTips('#mailRealNameRTip', '#mailRealNameETip', false, true, '');
                  _isMailName = true;
                } else {
                  commonJS.commonObj.controlWarnTips('#mailRealNameRTip', '#mailRealNameETip', false, false, '请输入真实的姓名');
                  _isMailName = false;
                }
              }
            });
  
            $('#mailRealNum').focusin(function () {
              var $ele = $(this);
              if ($ele.val() == this.defaultValue) {
                $ele.val('');
              }
              commonJS.commonObj.controlWarnTips('#mailRealNumRTip', '#mailRealNumETip', true, false, '');
              _isMailCard = false;
            }).blur(function () {
  
              var $ele = $(this);
              if ($.trim($ele.val()) == '') {
                $ele.val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#mailRealNumRTip', '#mailRealNumETip', true, false, '');
                _isMailCard = false;
              } else {
                var nowStr = $ele.val();
  
                var info = commonJS.commonObj.isCardID(nowStr);
                if (info == '') {
                  commonJS.commonObj.controlWarnTips('#mailRealNumRTip', '#mailRealNumETip', false, true, '');
                  _isMailCard = true;
                } else {
                  commonJS.commonObj.controlWarnTips('#mailRealNumRTip', '#mailRealNumETip', false, false, info);
                  _isMailCard = false;
                }
              }
  
            });
  
            /**********   mail account start **********/
            $("#mail-num").focusin(function () {
              if ($(this).val() == this.defaultValue) {
                $(this).val('');
              }
              commonJS.commonObj.controlWarnTips('#mail-numRightTip', '#mail-numErrorTip', true, false, '');
              _isMailNum = false;
            }).blur(function () {
              if ($.trim($(this).val()) == '') {
                $(this).val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#mail-numRightTip', '#mail-numErrorTip', true, false, '');
                _isMailNum = false;
              } else {
                var numStr = $('#mail-num').val();
                if (languageJS.languageObj.IsEmail(numStr) == true) {
                  _isMailNum = true;
                  commonJS.commonObj.controlWarnTips('#mail-numRightTip', '#mail-numErrorTip', false, true, '');
                } else {
                  commonJS.commonObj.controlWarnTips('#mail-numRightTip', '#mail-numErrorTip', false, false, languageJS.languageObj.MAIL_TRUE_FORMAT);
                  _isMailNum = false;
                }
              }
            });
  
            $('#mail-pwdWarn').focusin(function () {
              $('#mail-pwdWarn').hide();
              $("#mail-pwd").show();
              $("#mail-pwd").focus();
            });
  
            $('#mail-pwd').focusin(function () {
              $('#mail-pwdWarn').hide();
              commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', true, false, '');
              _isMailPwd = false;
            }).on('blur', function () {
              /*var oldStr = $(this).val();
              $(this).val(oldStr.replace(/\s/g, ''));*/
  
              _isMailPwd = false;
              var numStr = $('#mail-pwd').val();
              if ($.trim(numStr).length > 0) {
                if (languageJS.languageObj.IsPWD(numStr) == true) {
                  _isMailPwd = true;
                  commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', false, true, '');
  
                  var rePwd = $('#mail-repwd').val();
                  if (rePwd.length > 0) {
                    if (languageJS.languageObj.IsPWD(rePwd) == true) {
                      if (numStr == rePwd) {
                        _isMailPwd = true;
                        commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', false, true, '');
                      } else {
                        commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', false, false, languageJS.languageObj.PWD_NOT_SAME);
                      }
                    } else {
                      commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                    }
                  } else {
                    commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', true, false, '');
                    _isMailPwd = true;
                  }
                } else {
                  commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                }
              } else {
                $("#mail-pwd").hide();
                $('#mail-pwdWarn').show();
                commonJS.commonObj.controlWarnTips('#mail-pwdRightTip', '#mail-pwdErrorTip', true, false, '');
              }
            });
  
  
            $('#mail-repwdWarn').focusin(function () {
              $('#mail-repwdWarn').hide();
              $("#mail-repwd").show();
              $("#mail-repwd").focus();
            });
  
            $('#mail-repwd').focusin(function () {
              $('#mail-repwdWarn').hide();
              commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', true, false, '');
              _isMailRePwd = false;
            }).on('blur', function () {
              /*var oldStr = $(this).val();
              $(this).val(oldStr.replace(/\s/g, ''));*/
  
              _isMailRePwd = false;
              var numStr = $('#mail-repwd').val();
              if ($.trim(numStr).length > 0) {
                if (languageJS.languageObj.IsPWD(numStr) == true) {
                  var pwdStr = $('#mail-pwd').val();
                  if (pwdStr.length > 0) {
                    if (numStr != pwdStr) {
                      commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', false, false, languageJS.languageObj.PWD_NOT_SAME);
                    } else {
                      _isMailRePwd = true;
                      commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', false, true, '');
                    }
                  } else {
                    _isMailRePwd = true;
                    commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', false, true, '');
                  }
                } else {
                  commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', false, false, languageJS.languageObj.PWD_LIMIT_LENGTH);
                }
              } else {
  
                $("#mail-repwd").hide();
                $('#mail-repwdWarn').show();
                commonJS.commonObj.controlWarnTips('#mail-repwdRightTip', '#mail-repwdErrorTip', true, false, '');
              }
            });
  
            $('#mail-code').focusin(function () {
              if ($(this).val() == this.defaultValue) {
                $(this).val('');
              }
              commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', true, false, '');
              _isCodeNum = false;
            }).blur(function () {
              if ($.trim($(this).val()) == '') {
                $(this).val(this.defaultValue);
                commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', true, false, '');
                _isCodeNum = false;
              }
            }).on('keyup', function () {
  
              var emailNum = $('#mail-num').val();
  
              if (languageJS.languageObj.IsEmail(emailNum) == true) {
                /*var oldStr = $(this).val();
                $(this).val(oldStr.replace(/\s/g, ''));*/
  
                _isMailCode = false;
                _isCodeNum = false;
  
                if (_isMailHasCode == false) {
                  commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', false, false, '请先获取邮箱验证码');
                } else {
                  var numStr = $('#mail-code').val();
                  if (numStr.length > 0) {
                    if (numStr.length < 6) {
                      commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', false, false, '邮箱验证码需6位');
  
                    } else {
                      /*var mailNumStr = $('#mail-num').val();
                      if (languageJS.languageObj.IsEmail(mailNumStr) == true) {
                          reqCheckForCapchaAjax('mail-num', 'email', 'mail-code');
                      } else {
                          commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', true, false, '');
                      }*/
                      commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', true, true, '');
                      _isCodeNum = true;
                      _isMailCode = true;
                    }
                  } else {
                    commonJS.commonObj.controlWarnTips('#phone-codeRightTip', '#phone-codeErrorTip', false, false, '请输入邮箱验证码');
                  }
                }
              } else {
                $(this).val('');
                commonJS.commonObj.controlWarnTips('#mail-codeRightTip', '#mail-codeErrorTip', false, false, languageJS.languageObj.MAIL_TRUE_FORMAT);
                _isCodeNum = false;
              }
            });
  
            /**********  email account submit start **********/
  
            $('#mail-acceptBtn').click(function () {
              var errorStr = "";
  
              var mailNum = $('#mail-num').val();
              var mailDef = $('#mail-num')[0].defaultValue;
              var realNameStr = $('#phoneRealName').val();
              var realNameDef = $('#phoneRealName')[0].defaultValue;
              function textlength(res) {
                var len = 0;
                var str = res;
                for (var i = 0; i < str.length; i++) {
                  var c = str.charCodeAt(i);
                  //单字节加1
                  if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                    len++;
                  }
                  else {
                    len += 2;
                  }
                }
                return len
              };
              if (mailNum == mailDef) {
                $('#error-msg').html(mailDef)
                
                alert(mailDef);
              } else {
                if (_isMailNum == true) {
  
                  var mailPwd = $('#mail-pwd').val();
                  if (mailPwd.length > 0) {
                    if (_isMailPwd == true) {
                      var mailPwdRe = $('#mail-repwd').val();
                      if (mailPwdRe.length > 0) {
                        if (_isMailRePwd == true) {
                          if (mailPwd != mailPwdRe) {
                            $('#error-msg').html(languageJS.languageObj.PWD_NOT_SAME)
  
                            alert(languageJS.languageObj.PWD_NOT_SAME);
                          } else {
                            var realNameStr = $('#mailRealName').val();
                            var realNameDef = $('#mailRealName')[0].defaultValue;
                            if (realNameStr != realNameDef) {
                              if (textlength(realNameStr) < 4) {
                                alert("姓名不能少于两位汉字");
                                $('#error-msg').html('姓名不能少于两位汉字')
                              } else {
                                if (_isMailName == true) {
                                  var realNumStr = $('#mailRealNum').val();
                                  var realNumDef = $('#mailRealNum')[0].defaultValue;
                                  if (realNumStr != realNumDef) {
                                    if (_isMailCard == true) {
                                      var codeStr = $('#mail-code').val();
                                      var codeDef = $('#mail-code')[0].defaultValue;
                                      if (codeStr != codeDef) {
                                        if (_isCodeNum == true) {
                                          if ($('#mail-proxyRight').is(':visible') == false) {
                                $('#error-msg').html('还没有阅读并同意相关服务条款和隐私政策')
  
                                            alert('您还没有阅读并同意相关服务条款和隐私政策');
                                          } else {
                                            // function commonRegistFunc(userID, pwdID,pwdReID ,codeID,realName,realID) 
                                            commonRegistFunc('mail-num', 'mail-pwd', 'mail-repwd', 'mail-code', 'mailRealName', 'mailRealNum', 'mail');
                                          }
                                        }
                                      } else {
                                $('#error-msg').html(codeDef)
  
                                        alert(codeDef);
                                      }
                                    }
                                  } else {
                                $('#error-msg').html('请输入身份证号码')
  
                                    alert('请输入身份证号码');
                                  }
                                }
                              }
  
                            } else {
                              $('#error-msg').html('请输入真实的姓名')
  
                              alert('请输入真实的姓名');
                            }
                          }
                        }
                      } else {
                        $('#error-msg').html('请输入确认密码')
  
                        alert('请输入确认密码');
                      }
                    }
                  } else {
                    $('#error-msg').html('请输入密码')
  
                    alert('请输入密码');
                  }
  
                }
  
              }
  
            });
  
            $('#mail-getCodeBtn').click(function () {
              if (_isMailCooling == true) {
                return;
              } else {
                if (_isMailHasCode == false) {
                  _isMailHasCode = true;
                }
  
                var mailNumDefStr = $('#mail-num')[0].defaultValue;
                var mainNumStr = $('#mail-num').val();
  
                var errorStr = '';
                if (mainNumStr == mailNumDefStr) {
                  errorStr = mailNumDefStr;
                } else {
                  if (languageJS.languageObj.IsEmail(mainNumStr) == false) {
                    errorStr = languageJS.languageObj.MAIL_TRUE_FORMAT;
                  }
                }
  
                if (errorStr != '') {
                  alert(errorStr);
                } else {
                  startMailCooling();
  
                  var appkey = proxyJS.proxyObj.appKey;
                  var appId = proxyJS.proxyObj.appId;
                  var username = $('#mail-num').val().toLowerCase();
                  var from = 'register';
                  var type = 'email';
                  var signatureStr = appId + username + from + type + appkey;//appId+username+from+type+appkey
                  var signatureMd5 = $.md5(signatureStr);
  
                  var succFunc = function (res) {
                  }
  
                  var errorFunc = function (res) {
                    alert(res.msg);
                  }
                  try{
                    api.emailCode({
                      username: username,
                      appID: appID,
                      channelID: channelID,
                      subChannelID: subChannelID,
                      appKey: appKey
    
                    }, function (r) {
                      succFunc(r)
                    })
                  }catch{
                    
                  }
                  
                 
                  // proxyJS.proxyObj.reqPhoneOrMailCapchaAjax({
                  //     action: 'general',
                  //     appId: appId,
                  //     username: username,
                  //     from: from,
                  //     type: type,
                  //     signature: signatureMd5,
                  //     success: succFunc,
                  //     error: errorFunc
                  // });
                }
              }
            });
  
            $('#mail-proxyRecBox').click(function () {
              _isMailProxy = !_isMailProxy;
              if (_isMailProxy) {
                $('#mail-proxyRight').show();
              } else {
                $('#mail-proxyRight').hide();
              }
            });
  
          }
  
          function commonRegistFunc(userID, pwdID, pwdReID, codeID, realName, realID, type) {
            // alert(realID)
            userID = userID.indexOf('#') == -1 ? "#" + userID : userID;
            pwdID = pwdID.indexOf('#') == -1 ? "#" + pwdID : pwdID;
            pwdReID = pwdReID.indexOf('#') == -1 ? "#" + pwdReID : pwdReID;
            codeID = codeID.indexOf('#') == -1 ? "#" + codeID : codeID;
            realName = realName.indexOf('#') == -1 ? "#" + realName : realName;
            realID = realID.indexOf('#') == -1 ? "#" + realID : realID;
  
            var realNameStr = $(realName).val();
            var realIDStr = $(realID).val();
  
            var username = $(userID).val().toLowerCase();
  
            // var appId=getQueryVariable('appID')?getQueryVariable('appID'):proxyJS.proxyObj.appId
            var appId = proxyJS.proxyObj.appId;
            var appKey = proxyJS.proxyObj.appKey;
            var pwd = $(pwdID).val();
            var pwdRe = $(pwdReID).val();
            var pwdMd5 = $.md5(pwd);
            var pwdReIDMd5 = $.md5(pwdRe);
            var channel = -1;
            var signature = appId + username + pwdMd5 + channel + appKey;
            var signatureMd5 = $.md5(signature);
            var captcha = $(codeID).val();
            // alert('----')
            var succFunc = function (res) {
              console.log(res)
              // alert('0')
              cookie('username', null, { path: '/' });
              cookie('userkey', null, { path: '/' });
              // cookie('useuid', null, {path: '/'});
              cookie('phone', null, { path: '/' });
              cookie('email', null, { path: '/' });
              cookie('findpwdcode', null, { path: '/' });
              cookie('aofeilastusername', null, { path: '/' });
              cookie('realNum', null, { path: '/' });
              cookie('realName', null, { path: '/' });
  
              cookie('username', res.data.username, { path: '/' });
              cookie('userkey', res.data.accessToken, { path: '/' });
              // cookie('useruid', res.data.uid, {path: '/'});
              cookie('phone', res.data.phone, { path: '/' });
              cookie('email', res.data.email, { path: '/' });
              cookie('realNum', res.data.idcard, { path: '/' });
              cookie('realName', res.data.realname, { path: '/' });
  
  
              $('#c-logIn').hide();
              $('#c-c-elb span').html(res.data.username);
              $('#c-c-elb').show();
  
              $('body').css({
                'overflow-y': 'visible'
              });
              var callback = getQueryVariable("callback")
              if (callback) {
                // location.reload()
                window.location.href = callback
              } else {
                window.location.href = '/passport/registSuccess.html';
  
              }
  
            }
  
            var errorFunc = function (res) {
              alert(res.msg);
            }
            if (type == 'mail') {
              try{
  api.emailRegister({
                username: username,
                password: pwdMd5,
                rePassword: pwdReIDMd5,
                realname: realNameStr,
                idcard: realIDStr,
                appID: appId,
                captcha: captcha,
                channelID: channelID,
                subChannelID: subChannelID,
                appKey: appKey
              }, function (r) {
                succFunc(r)
              })
              }catch{
                
              }
              
            } else {
              try{
  api.initRegister({
                username: username,
                password: pwdMd5,
                rePassword: pwdReIDMd5,
                realname: realNameStr,
                idcard: realIDStr,
                appID: appId,
                captcha: captcha,
                channelID: channelID,
                subChannelID: subChannelID,
                appKey: appKey
              }, function (r) {
                if(r.code==0){
                  succFunc(r)
                  $('#error-msg').html('')
                }else{
                  alert(r.msg)
                  $('#error-msg').html(r.msg)
  
                }
              })
              }catch{
                
              }
              
            }
  
  
  
            // proxyJS.proxyObj.reqCommonRegistAjax({
            //     action: 'generalRegister',
            //     appId: appId,
            //     username: username,
            //     password: pwdMd5,
            //     channel: channel,
            //     signature: signatureMd5,
            //     captcha: captcha,
            //     cardno:realIDStr,
            //     realname:realNameStr,
            //     success: succFunc,
            //     error: errorFunc
            // });
          }
  
          resetRegistUI.call(this);
          initRegistNav.call(this);
          initPhonePanelLogic.call(this);
          initMailPanelLogic.call(this);
  
        }
      })
    }
  }
  
  exports.registObj = registObj;
  

});
